import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import TopNav from '../components/navigation_bar/TopNav';
import maxHuddlestonImg from '../assets/images/maxhuddleston.jpg';
import './../assets/css/home.css';

function Home() {
    const navigate = useNavigate();
    const location = useLocation();
    const { isAuthenticated } = useAuth();

    const scrollToAbout = () => {
        document.getElementById('about-section')?.scrollIntoView({ behavior: 'smooth' });
    };

    useEffect(() => {
        if (location.hash === '#about-section' || location.hash === '#about') {
            scrollToAbout();
        }
    }, [location.hash]);

    const handleGetStarted = () => {
        if (isAuthenticated) {
            navigate('/dashboard');
        } else {
            navigate('/get-started');
        }
    };

    return (
        <div className="body">
            <TopNav />
            <div className="home-container">
                <div className="home-content">
                    <h1>Let's make language learning <span className="highlight">easy.</span></h1>
                    <p>Welcome to FreeFlash</p>
                    <button className="get-started-button" onClick={handleGetStarted}>
                        {isAuthenticated ? "Continue Learning" : "Get Started"}
                    </button>
                    <button className="learnmore-button" onClick={scrollToAbout}>Learn More</button>
                </div>
            </div>
            <div className="about-section" id="about-section">
                <div className="about-content">
                    <div className="about-header">
                        <h1>About FreeFlash</h1>
                    </div>

                    <div className="about-editorial-card">
                        <p className="about-lead">
                            FreeFlash is a platform created to help people quickly learn new languages for free, using techniques that mimic how native speakers actually learn. Track your progress, and review topics at your own pace. Whether you're a beginner or an advanced learner, FreeFlash makes language learning simple, effective, and accessible to everyone.
                        </p>

                        <div className="about-divider" role="separator" aria-hidden="true"></div>

                        <div className="about-creator-section">
                            <div className="about-avatar-wrapper">
                                <a
                                    href="https://www.linkedin.com/in/max-huddleston/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="about-avatar-link"
                                    title="Max LinkedIn Profile"
                                >
                                    <img
                                        src={maxHuddlestonImg}
                                        alt="Max Huddleston"
                                        className="about-avatar-img"
                                    />
                                </a>
                            </div>

                            <div className="about-creator-details">
                                <div className="about-creator-header">
                                    <h2 className="about-creator-name">Max</h2>
                                    <span className="about-creator-badge">Developer</span>
                                </div>

                                <p className="about-creator-bio">
                                    Hey, I'm an athlete, musician, and college student! I was inspired to build FreeFlash while visiting Brazil in summer 2026.
                                </p>

                                <div className="about-social-links">
                                    <a
                                        href="https://www.linkedin.com/in/max-huddleston/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="about-social-pill linkedin"
                                        title="LinkedIn Profile"
                                    >
                                        <svg className="social-icon" viewBox="0 0 24 24" fill="currentColor" width="16" height="16" aria-hidden="true">
                                            <path d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.28 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.75M6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77z" />
                                        </svg>
                                        <span>LinkedIn</span>
                                    </a>

                                    <a
                                        href="https://www.instagram.com/maxhud95/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="about-social-pill instagram"
                                        title="Instagram @maxhud95"
                                    >
                                        <svg className="social-icon" viewBox="0 0 24 24" fill="currentColor" width="16" height="16" aria-hidden="true">
                                            <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z" />
                                        </svg>
                                        <span>Instagram</span>
                                    </a>

                                    <a
                                        href="mailto:maxhuddleston@berkeley.edu"
                                        className="about-social-pill email"
                                        title="Email maxhuddleston@berkeley.edu"
                                    >
                                        <svg className="social-icon" viewBox="0 0 24 24" fill="currentColor" width="16" height="16" aria-hidden="true">
                                            <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
                                        </svg>
                                        <span>Email</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <footer className="home-footer">
                <p className="home-footer-copy">© {new Date().getFullYear()} FreeFlash (Prototype). All rights reserved.</p>
                <div className="home-footer-links">
                    <a href="/terms-of-service">Terms of Service</a>
                </div>
            </footer> */}
        </div >
    );
}

export default Home;
